import {useMemo, useState} from "react";

export type ErrorMapper = (error: unknown) => string
export type ErrorMapperHolder = {
    mapper: ErrorMapper
}
type SetErrorMapper = (mapper:ErrorMapper) =>void

export const defaultErrorMapper: ErrorMapper = (error: unknown) => {
    return "Ein Fehler ist aufgetreten.";
}

export function useErrorMapper():[ErrorMapper,SetErrorMapper]{
    const [errorMapperHolder, setErrorMapperHolder] = useState<ErrorMapperHolder>({mapper: defaultErrorMapper});
    const errorMapper = errorMapperHolder.mapper;
    const setErrorMapper = (mapper:ErrorMapper) => {
        setErrorMapperHolder({
            mapper: mapper
        })
    }

    return [errorMapper, setErrorMapper]
}
